'use client';

import { Fragment } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, ChevronDownIcon, XMarkIcon } from '@heroicons/react/24/outline'
import Logo from '../shared/logo';
import { signOut, useSession } from 'next-auth/react';
import ProfileNav from './profileNav';
import LinksNav from './linksNav';
import LinksNavMobile from './linksNavMobile';




function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

export default function Nav() {
  const session = useSession()

  return (
    <Disclosure as="nav" className="relative sticky top-0 z-50 bg-white shadow header-main">
      {({ open }) => (
        <>
          <div className="container py-3 lg:mx-auto">
            {/* <div className="flex h-16">
              <div className="flex flex-1 justify-between"> */}
            <div className="flex justify-between md:hidden">
              <div className='flex align-items-center'>
                <a href='/' className='header__logo'>
                  <Logo />
                </a>
              </div>
              <Disclosure.Button className="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-gray-500 ms-auto hover:bg-zinc-100 ">
                <span className="sr-only">Open user menu</span>
                {open ? (
                  <XMarkIcon className="block h-10 w-10" aria-hidden="true" />
                ) : (
                  <Bars3Icon className="block h-10 w-10" aria-hidden="true" />
                )}
              </Disclosure.Button>
              <div className='pt-1'>
                <ProfileNav />
              </div>
            </div>

            <div className="hidden md:flex 2xl:space-x-6 xl:space-x-6 lg:space-x-6 md:space-x-6 sm:space-x-6 align-items-center 2xl:gap-5 ">
              <a href='/' className=''>
                <Logo />
              </a>
              <div className='flex lg:space-x-6 xl:space-x-1 md:space-x-3  space-x-0 justify-start mx-auto fs-100 gap-300 mt-3'>
                <LinksNav />
              </div>
              <div className='flex' style={{ marginLeft: 'auto' }}>
                <ProfileNav />
              </div>
            </div>

            {/* </div>

            </div> */}
          </div>

          {/* Mobile menu */}
          <Disclosure.Panel className="lg:hidden">
            <div>
              <div className="pt-2 pb-3 space-y-1">
                <LinksNavMobile />
              </div>
            </div>

          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
